import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { useHostedInstance } from '../../contexts/HostedInstanceContext';

import PaymentMode from '../../enums/PaymentMode.const';
import { getCartTotal } from '../../selectors/appSelectors';
import {
  getPaymentConfig,
  getPaymentModeConfig,
  getStylesConfig
} from '../../selectors/configSelectors';

function HostedForm(props) {
  const { initHostedInstance } = useHostedInstance();
  const isFirstRender = useRef(true);

  useEffect(
    () => {
      if (isFirstRender.current) {
        // Init instance on mount
        initHostedInstance(
          props.payment_mode.mode === PaymentMode.HP
            ? 'hosted-payments'
            : props.payment_mode.method,
          props.config
        );
        isFirstRender.current = false;
      } else {
        const handler = setTimeout(() => {
          initHostedInstance(
            props.payment_mode.mode === PaymentMode.HP
              ? 'hosted-payments'
              : props.payment_mode.method,
            props.config
          );
        }, 2000);

        return () => {
          clearTimeout(handler);
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.cartTotal]
  );

  return <div id="hosted-form-container" />;
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    payment_mode: getPaymentModeConfig(state),
    config: {
      ...state.appReducer.hostedInstanceConfig,
      ...getPaymentConfig(state),
      styles: { ...getStylesConfig(state) }
    },
    cartTotal: getCartTotal(state)
  };
};

export default connect(mapStateToProps, null)(HostedForm);
